export enum RewardStatus {
  'Active' = 0,
  'Claimed',
  'Expired',
  'Cancelled',
  'Pending Approval',
  'Inactive',
  'Failed',
}
